import React from 'react';
import PropTypes from 'prop-types';
import { MotifProgressBar } from '../../progress-bar/progress-bar';

/**
 * @typedef Props
 * @prop {number} [progress]
 * @prop {boolean} [past]
 */
/**
 * @param {Props} props
 */
/**
 * @type React.FC<Props>
 */
const Milestone = React.memo(
  ({ progress = null, past = false }) => {
    const progressValue = progress === null && past ? 100 : progress;

    return (
      <React.Fragment>
        <MotifProgressBar value={progressValue} circle />
        {progressValue === 100 && (
          <div className="motif-timeline-checkmark" aria-label="complete checkmark" />
        )}
        {progressValue < 100 && (
          <React.Fragment>
            {!past && (
              <div className="motif-timeline-no-checkmark" aria-label="completed no checkmark" />
            )}
            {past && <div className="motif-timeline-x" aria-label="not completed crossmark" />}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  },
  (prevProps, nextProps) =>
    prevProps.progress === nextProps.progress && prevProps.past === nextProps.past
);

Milestone.propTypes = {
  progress: PropTypes.number,
  past: PropTypes.bool
};

export default Milestone;
